module.exports = __webpack_public_path__ + "img/content7-8.50bd2bb7.webp";